export default __webpack_public_path__ + "static/media/progress_1.c21e6362.svg";